const s = "UserInitials_tbvUq", t = {
  UserInitials: s
};
export {
  s as UserInitials,
  t as default
};
//# sourceMappingURL=userInitials.module.scss.js.map
